<template>
  <drag-wrap
    v-if="compVisible"
    :visible="compVisible"
    modalId="quiz-student-modal"
    modalName="答题器"
  >
    <div class="student-answer-container">
      <!-- 答题器主界面 -->
      <div v-if="!showResultDialog" class="answer-card">
        <!-- 头部 -->
        <div class="card-header">
          <div class="header-left">
            <span class="title">答题器</span>
            <span v-if="showSubmitted" class="submit-status">
              已提交
              <img
                width="20px"
                class="right-icon"
                src="@saas/pages/assets/images/live/is-right.png"
                alt=""
              />
            </span>
          </div>
          <div class="header-right">
            <div class="timer">
              <i class="el-icon-time"></i>
              <span class="time-text">{{ formatTime(remainingTime) }}</span>
            </div>
          </div>
        </div>

        <!-- 选项区域 -->
        <div class="options-container">
          <div
            class="options-wrapper"
            v-if="!isSubmitted || isModifying"
            :class="{
              judge: questionType === 3,
            }"
          >
            <!-- 题目类型标签 -->
            <span class="question-type-tag type-tag" :class="getTypeTagClass()">
              {{ getQuestionTypeText() }}
            </span>
            <div
              v-for="(option, index) in options"
              :key="index"
              class="option-item"
              :class="{
                'option-selected': selectedOption.includes(option),
                'option-disabled': isSubmitted && !isModifying,
              }"
              @click="handleOptionClick(option)"
            >
              <div class="option-content">
                <span class="option-text">{{ option }}</span>
              </div>
            </div>
          </div>
          <div
            class="options-wrapper"
            v-else
            :class="{
              judge: questionType === 3,
            }"
          >
            <!-- 题目类型标签 -->
            <span class="question-type-tag type-tag" :class="getTypeTagClass()">
              {{ getQuestionTypeText() }}
            </span>
            <div
              class="option-item no-hover"
              v-for="(option, index) in selectedOption"
              :key="index"
            >
              <div class="option-content">
                <span class="option-text">{{ option }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部按钮 -->
        <div class="bottom-actions">
          <!-- 提交状态 -->
          <template v-if="!isSubmitted && !isModifying">
            <el-button
              type="primary"
              :class="{
                'btn-enabled': selectedOption.length,
                'is-disabled': !selectedOption.length,
              }"
              @click="handleSubmit"
            >
              提交
            </el-button>
          </template>

          <!-- 已提交状态 -->
          <template v-if="isSubmitted && !isModifying">
            <el-button
              type="primary"
              plain
              @click="handleModifyAnswer"
              class="blur"
            >
              修改答案
            </el-button>
          </template>

          <!-- 修改答案状态 -->
          <template v-if="isModifying">
            <div class="modify-actions">
              <el-button type="primary" plain @click="handleCancelModify"
                >返回</el-button
              >
              <el-button
                type="primary"
                class="btn-enabled"
                @click="handleSubmit"
              >
                保存
              </el-button>
            </div>
          </template>
        </div>
      </div>

      <!-- 答题结果页面 -->
      <div v-if="showResultDialog" class="result-card">
        <!-- 头部 -->
        <div class="result-header">
          <div class="header-left">
            <span class="title">答题器</span>
          </div>
          <div class="header-right" @click="closeResultDialog">
            <div class="countdown">
              <span class="countdown-text">关闭({{ countdownTime }}s)</span>
            </div>
          </div>
        </div>

        <!-- 结果内容 -->
        <div class="result-content">
          <!-- 题目类型标签 -->
          <span class="question-type-tag type-tag" :class="getTypeTagClass()">
            {{ getQuestionTypeText() }}
          </span>
          <div class="result-display">
            <div class="result-text">
              <template v-if="resultStatus === 'correct'">
                <span class="status-text">回答正确</span>
                <span
                  v-if="selectedOption"
                  class="answer-text"
                  :class="{ [resultStatus]: true }"
                >
                  {{ selectedOption.join(" ") }}
                </span>
                <img
                  class="status-icon right-icon"
                  src="@saas/pages/assets/images/live/is-right.png"
                  alt=""
                />
              </template>
              <template v-else-if="resultStatus === 'incorrect'">
                <span class="status-text">回答错误</span>
                <span class="answer-text" :class="{ [resultStatus]: true }">{{
                  selectedOption.join(" ")
                }}</span>
                <img
                  class="status-icon right-icon"
                  src="@saas/pages/assets/images/live/is-error.png"
                  alt=""
                />
              </template>
              <template v-else-if="resultStatus === 'not-answered'">
                <span class="status-text">未作答</span>
                <!-- <span
                  v-if="selectedOption"
                  class="answer-text"
                  :class="{ [resultStatus]: true }"
                >
                  {{ selectedOption.join(" ") }}
                </span> -->
                <img
                  class="status-icon right-icon"
                  src="@saas/pages/assets/images/live/is-no-answer.png"
                  alt=""
                />
              </template>
              <template v-else>
                <span class="status-text">未公布答案</span>
                <span
                  v-if="selectedOption"
                  class="answer-text"
                  :class="{ [resultStatus]: true }"
                >
                  {{ selectedOption.join(" ") }}
                </span>
                <img
                  class="status-icon right-icon"
                  src="@saas/pages/assets/images/live/is-no-answer.png"
                  alt=""
                />
              </template>
            </div>
          </div>
        </div>

        <!-- 底部按钮 -->
        <div class="result-footer">
          <el-button
            type="primary"
            plain
            class="blur"
            @click="closeResultDialog"
          >
            确认关闭
          </el-button>
        </div>
      </div>
    </div>
  </drag-wrap>
</template>

<script>
import AccurateTimer from "./accurateTimer";
import { DragWrap } from "@saas/components";
import { mapMutations, mapState } from "vuex";
import { submitAnswer } from "@saas/server-api/src/live-sdk";

export default {
  name: "StudentAnswer",
  components: {
    DragWrap,
  },
  props: {
    // 题目数据
    toolboxStatus: {
      type: Object,
      default: () => ({
        allOption: [],
        endTime: 0,
        id: 0,
        questionType: 0,
        rightOption: [],
        roomId: 0,
        version: 0,
      }),
    },
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("live", ["imService", "whiteBoardService", "roomInfo"]),
    userInfo() {
      return this.$store.getters.user || {};
    },
  },
  data() {
    return {
      id: 0,
      compVisible: false,
      // 选项数据
      options: [],
      // 选中的选项
      selectedOption: [],
      // 剩余时间（秒）
      remainingTime: 0,
      // 是否已提交
      isSubmitted: false,
      // 是否正在修改答案
      isModifying: false,
      // 计时器
      timer: null,
      // 结果弹窗
      showResultDialog: false,
      // 结果状态：correct, incorrect, not-answered, unknown
      resultStatus: "unknown",
      // 题目类型
      questionType: "",
      // 倒计时时间
      countdownTime: 5,
      // 倒计时定时器
      countdownTimer: null,
      // IM消息监听器
      imMessageListener: null,
      // 正确答案
      rightOption: [],
      showSubmitted: false,
      reStart: false,
      createdAt: 0,
      timeDifference: 0,
      submitRemainingTime: 0,
      subOption: [],
    };
  },
  watch: {
    visible: {
      handler(newVal) {
        this.compVisible = newVal;
        if (newVal) {
          this.initAnswer();
        }
      },
      immediate: true,
    },
    imService: {
      handler(val, oldVal) {
        if (val && !oldVal) {
          this.handleImListener();
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    ...mapMutations("live", ["setShowToolbox"]),
    // 获取题目类型文本
    getQuestionTypeText() {
      const typeMap = {
        1: "单选",
        2: "多选",
        3: "判断",
      };
      return typeMap[this.questionType] || "单选";
    },

    // 获取题目类型标签样式类
    getTypeTagClass() {
      const typeClassMap = {
        1: "single-choice",
        2: "multiple-choice",
        3: "true-false",
      };
      return typeClassMap[this.questionType] || "single-choice";
    },

    // 处理IM消息监听
    handleImListener() {
      if (this.imService) {
        this.imService.on(
          "recvMGLiveRoomCustomMsg",
          this.handleLiveRoomCustomMsg
        );
      }
    },

    // 处理直播间自定义消息
    handleLiveRoomCustomMsg(res) {
      if (res.data && res.data.type === "question") {
        this.handleImMessage(res.data.data);
      }
    },
    // 处理IM消息
    handleImMessage(data) {
      console.log("StudentAnswer收到IM消息:", data);

      switch (data?.event) {
        case "start":
          // 老师开始答题
          this.handleQuizStart(data);
          break;
        case "end":
          // 老师结束答题
          this.handleQuizEnd(data);
          break;
      }
    },

    // 处理答题开始
    handleQuizStart(data) {
      console.log("收到答题开始通知:", data);
      // 重新初始化答题器
      this.reStart = true;
      this.initAnswer();
      // 显示答题器
      this.compVisible = true;

      this.id = data.id;
      this.createdAt = data.createdAt;
      this.options = data.allOption || [];
      this.questionType = data.questionType || 1;
      this.timeDifference = data.serverTime - new Date().getTime();
      // 未提交答案，开始计时
      this.startTimer();
    },

    // 处理答题结束
    async handleQuizEnd(data) {
      console.log("收到答题结束通知:", data);

      // 停止计时
      this.clearTimer();

      const rightOptions = data.rightOption || [];
      if (!this.isSubmitted) {
        // 未作答
        this.resultStatus = "not-answered";
      } else if (!rightOptions.length) {
        this.resultStatus = "unknown"; // 未公布答案
      } else {
        // 已公布答案
        const studentAnswer = this.selectedOption;
        if (this.questionType === 3) {
          this.resultStatus =
            studentAnswer[0] === rightOptions[0] ? "correct" : "incorrect";
        } else {
          this.resultStatus =
            JSON.stringify(studentAnswer) === JSON.stringify(rightOptions)
              ? "correct"
              : "incorrect";
        }
        this.rightOption = rightOptions;
      }
      // 显示结果弹窗
      this.showResultDialog = true;
      this.startCountdown();
    },

    // 初始化答题器
    initAnswer() {
      console.log(this.toolboxStatus, "toolboxStatus");
      if (this.toolboxStatus.id && !this.reStart) {
        this.$nextTick(() => {
          this.id = this.toolboxStatus.id;
          this.timeDifference =
            this.toolboxStatus.serverTime - new Date().getTime();
          // console.log(this.timeDifference, "timeDifference");
          this.options = this.toolboxStatus.allOption || [];
          this.selectedOption = this.toolboxStatus.subOption || [];
          this.subOption = JSON.parse(JSON.stringify(this.selectedOption));
          this.isSubmitted = this.selectedOption.length > 0;
          this.questionType = this.toolboxStatus.questionType || 1;
          this.createdAt = this.toolboxStatus.createdAt;
          if (this.selectedOption.length) {
            // 已提交
            this.remainingTime = this.toolboxStatus.answerTime;
          } else {
            this.remainingTime = Math.floor(
              this.toolboxStatus.serverTime / 1000 - this.createdAt
            );
          }
          this.submitRemainingTime = this.remainingTime;
          if (!this.isSubmitted) {
            // 未提交答案，开始计时
            this.startTimer(this.remainingTime || 0);
          } else {
            this.clearTimer();
          }
        });
      } else {
        this.resetAnswer();
      }
    },

    // 重置答题器
    resetAnswer() {
      this.selectedOption = [];
      this.isSubmitted = false;
      this.isModifying = false;
      this.showResultDialog = false;
      this.resultStatus = "unknown";
      this.countdownTime = 5;
      this.submitRemainingTime = 0;
      this.clearTimers();
    },

    // 开始计时
    startTimer(startTime = 0) {
      this.remainingTime = startTime;
      // this.timer = setInterval(() => {
      //   this.remainingTime++;
      // }, 1000);
      this.timer = new AccurateTimer(
        () => {
          this.remainingTime++;
        }, // 回调函数
        1000, // 时间间隔
        {
          immediate: false,
          vueInstance: this, // 传入当前组件实例
        }
      );
      this.timer.start();
    },

    // 清除计时器
    clearTimer() {
      if (this.timer) {
        // clearInterval(this.timer);
        this.timer.stop();
        this.timer = null;
      }
    },

    // 清除所有定时器
    clearTimers() {
      this.clearTimer();
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },

    // 格式化时间
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
        .toString()
        .padStart(2, "0")}`;
    },

    // 选择选项
    handleOptionClick(value) {
      if (this.isSubmitted && !this.isModifying) {
        return;
      }
      if (this.questionType === 2) {
        const index = this.selectedOption.indexOf(value);
        if (index > -1) {
          this.selectedOption.splice(index, 1);
        } else {
          this.selectedOption.push(value);
        }
      } else {
        this.selectedOption = [value];
      }
    },

    // 提交答案
    async handleSubmit() {
      if (!this.selectedOption.length || this.loading) {
        return;
      }

      try {
        // 调用提交接口
        this.loading = true;
        const res = await submitAnswer({
          id: this.id,
          sub_option: this.selectedOption,
        });

        console.log("提交答案成功:", res);

        if (res.code === 1) {
          this.showSubmitted = true;
          this.selectedOption = res.data.sub_option;
          this.subOption = JSON.parse(JSON.stringify(this.selectedOption));
          this.remainingTime = Math.floor(
            res.serverTime / 1000 - res.data.created_at
          );
          this.submitRemainingTime = this.remainingTime;
          this.handleCancelModify();
          this.clearTimer(); // 停止计时
          this.broadcastAnswerEvent("submit", {});
          setTimeout(() => {
            this.showSubmitted = false;
          }, 5000);
          this.isSubmitted = this.subOption.length > 0;
        } else {
          this.$message.error(res.message);
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error("提交答案失败:", error);
        this.$message.error("提交失败，请重试");
      }
    },

    // 发送答题通知给学生端
    broadcastAnswerEvent(event, data) {
      if (this.imService) {
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "question",
            data: {
              event: event,
              ...data,
            },
          },
        });
      }
    },

    // 修改答案
    handleModifyAnswer() {
      this.isModifying = true;
      this.startTimer(
        Math.floor(
          (new Date().getTime() + this.timeDifference - this.createdAt * 1000) /
            1000
        )
      );
    },

    // 取消修改
    handleCancelModify() {
      this.isModifying = false;
      this.selectedOption = JSON.parse(JSON.stringify(this.subOption));
      this.remainingTime = this.submitRemainingTime;
      this.clearTimer();
    },

    // 开始倒计时
    startCountdown() {
      this.reStart = false;
      this.countdownTime = 5;
      this.countdownTimer = setInterval(() => {
        if (this.countdownTime > 0) {
          this.countdownTime--;
        } else {
          if (!this.reStart) {
            this.setShowToolbox({
              answerer: false,
            });
            this.closeResultDialog();
          } else {
            clearInterval(this.countdownTimer);
            this.countdownTimer = null;
          }
        }
      }, 1000);
    },

    // 关闭结果页面
    closeResultDialog() {
      this.showResultDialog = false;
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      // 关闭整个答题器
      this.compVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.student-answer-container {
  width: 327px;
  height: 266px;
  background: #000000;
  border-radius: 12px;
  overflow: hidden;

  .answer-card {
    width: 100%;
    height: 100%;
    background: #18181b;
    border: 2px solid #27272a;
    border-radius: 12px;
    box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    padding: 16px 16px 0px;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;

    .header-left {
      display: flex;
      align-items: center;
      .title {
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 18px;
        line-height: 28px;
        color: #c9cdd4;
      }
    }

    .submit-status {
      color: #00b42a;
      display: flex;
      align-items: center;
      margin-left: 12px;
      font-size: 14px;
      img {
        display: inline-block;
        margin-left: 4px;
      }
    }

    .header-right {
      .timer {
        display: flex;
        align-items: center;
        gap: 5px;

        .el-icon-time {
          color: #ffffff;
          font-size: 20px;
        }

        .time-text {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 18px;
          line-height: 28px;
          color: #c9cdd4;
          text-align: right;
        }
      }
    }
  }

  .options-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 293px;
    flex: 1;

    .question-type-tag {
      top: 5px;
    }

    .options-wrapper {
      display: flex;
      align-items: center;
      gap: 16px;
      background: #1e1e20;
      border-radius: 12px;
      flex-wrap: wrap;
      width: 100%;
      padding: 24px 42px;
      justify-content: center;
      position: relative;

      &.judge {
        padding: 24px 0;
        .option-item {
          width: 130px;
        }
      }

      .option-item {
        width: 40px;
        height: 40px;
        border-radius: 12px;
        background: #303031;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
        &:hover:not(.option-disabled, .no-hover) {
          background: #165dff;
        }

        &.option-selected {
          background: #165dff;
        }

        &.option-disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }

        .option-content {
          display: flex;
          .option-text {
            font-family: Inter;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #ffffff;
            text-align: center;
          }
        }
      }
    }
  }

  .bottom-actions {
    padding: 16px 0;
    display: flex;
    justify-content: stretch;
    align-items: stretch;
    gap: 8px;

    .modify-actions {
      display: flex;
      gap: 8px;
      width: 100%;

      .el-button {
        flex: 1;
      }
    }
  }

  // 结果页面样式
  .result-card {
    width: 100%;
    height: 100%;
    background: #18181b;
    border: 2px solid #27272a;
    border-radius: 12px;
    box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
    display: flex;
    flex-direction: column;
    padding: 12px 16px 0px;
  }

  .result-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 29px;

    .header-left {
      .title {
        font-family: PingFang SC;
        font-weight: 600;
        font-size: 18px;
        line-height: 28px;
        color: #c9cdd4;
      }
    }

    .header-right {
      .countdown {
        display: flex;
        align-items: center;
        gap: 5px;

        .countdown-text {
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 14px;
          line-height: 28px;
          color: #c9cdd4;
          text-align: right;
        }
      }
    }
  }

  // 题目类型标签
  .question-type-tag {
    position: absolute;
    top: 0;
    left: 6px;
  }
  .type-tag {
    display: inline-block;
    padding: 1px 9px;
    border-radius: 6px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;

    &.single-choice {
      color: #ffe4ba;
      background: #774b04;
    }

    &.multiple-choice {
      color: #b5f4ea;
      background: #03616c;
    }

    &.true-false {
      color: #ddbef6;
      background: #27066e;
    }
  }

  .result-content {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    position: relative;

    .question-type-tag {
      top: 5px;
    }

    .result-display {
      background: #1e1e20;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      max-width: 293px;
      height: 100%;

      .result-text {
        display: flex;
        align-items: center;
        gap: 4px;
        font-family: Inter;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
        text-align: center;

        .status-text {
          font-weight: 600;
        }

        .answer-text {
          font-weight: 500;
          color: #fff;
          &.correct {
            color: #00b42a;
          }
          &.incorrect {
            color: #f53f3f;
          }
        }
        .status-icon {
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .result-footer {
    padding: 16px 0;
    display: flex;
    justify-content: stretch;
    align-items: stretch;
    margin-top: 29px;
    gap: 8px;
  }

  .el-button {
    flex: 1;
    height: 40px;
    border-radius: 12px;
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 14px;
    &.el-button--primary.is-plain,
    &.is-disabled {
      opacity: 1 !important;
      background: #28282c;
      background-color: #28282c !important;
      border-color: #28282c !important;
      color: #e8f3ff !important;
      &.blur {
        color: #4080ff !important;
      }
    }
    &.el-button--primary.btn-enabled {
      background: #165dff;
      border-color: #165dff;
      &:hover {
        background: #0e42d2 !important;
        border-color: #0e42d2 !important;
      }
    }
  }
}
</style>
